import React from 'react'

const Play = () => (
    <svg width="51" height="51" viewBox='0 0 51 51' xmlns="http://www.w3.org/2000/svg"><g transform="translate(.75 .75)" stroke="#000" strokeWidth="1.5" fill="none" fillRule="evenodd"><circle cx="24.75" cy="24.75" r="24.75"/><path d="m36.066 24.067-15.75 9.094V14.974z"/></g></svg>
)

export default Play